import { baseUrl } from '../config/clientsConfig'
import axios from "axios";

const teamService ={
  fetchTeams: (body) => axios.post(`${baseUrl}/teams`, body),
  validateTeamName: (name) => axios.post(`${baseUrl}/validateteamName`, { name }),
  createTeam: (teamData) => axios.post(`${baseUrl}/team`, teamData),
  updateTeam: (teamId, teamData) => axios.put(`${baseUrl}/team/${teamId}`, teamData),
  getTeamData: (teamId) => axios.get(`${baseUrl}/team/${teamId}`),
  getTeamName: () => axios.get(`${baseUrl}/teams-name`),
  getUserName : () => axios.get(`${baseUrl}/users-name`),
}

 export default teamService;